module.exports = __webpack_public_path__ + "static/media/tapeta_02.0c5b9eb4.jpg";